module.exports = { get, list }

const tools = require('../../tools')

// TODO: the final filter should be moved out of DAL and into tools
function get (state, { entityId, entityType, proposalId, date }) {
  if (proposalId) {
    return state.proposalsDB.get(proposalId)
      .then(tools.docToEntity)
  }

  return state.proposalsDB.allDocs({
    include_docs: true,
    startkey: `proposal:${entityType}:id:${entityId}:`,
    endkey: `proposal:${entityType}:id:${entityId}:\uffff`
  })
    .then(({ rows }) => {
    // Ignore proposals made in past reporting periods
      rows = rows.filter(row => row.doc.effectiveDate >= date)
      const lastRow = rows[rows.length - 1]
      return lastRow
        ? tools.docToEntity(lastRow.doc)
        : null
    })
}

function list (state, { entityType, currentEntities, startDate, endDate }, filters = {}) {
  // Default proposal view
  let viewName = tools.constants.BY_EFFECTIVE_DATE_VIEW_NAME
  let query = {
    startkey: [`proposal:${entityType}`, startDate],
    endkey: [`proposal:${entityType}`, endDate],
    include_docs: true
  }
  if (entityType === 'location' && filters.countryId) {
    viewName = tools.constants.LOCATIONS_BY_COUNTRY_AND_EFFECTIVE_DATE_VIEW_NAME
    query = {
      startkey: [filters.countryId, startDate],
      endkey: [filters.countryId, endDate],
      include_docs: true
    }
  }
  return queryAllPages(state.proposalsDB, viewName, query)
    .then(rows => rows.map(row => tools.docToEntity(row.doc)))
    .then(proposalEntities => tools.listWithProposals({ currentEntities, proposalEntities }))
}

const PAGE_LIMIT = 500

async function queryAllPages (proposalsDb, viewName, query) {
  const rows = []
  let skip = 0

  while (true) {
    const pageQuery = Object.assign({}, query, {
      limit: PAGE_LIMIT,
      skip: skip
    })
    const response = await proposalsDb.query(viewName, pageQuery)

    if (!response || !response.rows || response.rows.length === 0) {
      break
    }

    rows.push(...response.rows)

    if (response.rows.length < PAGE_LIMIT) {
      break
    }

    skip += response.rows.length
  }

  return rows
}
